import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import emptyDocument from "../../assets/images/fallback.svg";
import "../../design-system.css";
import { isValidArray, isValidObject } from "../../services/validators";
import { rippleEffect } from "../../utils/Functions";
import AudioPlayer from "../AudioPlayer/AudioPlayer";
import Button from "../Button/Button";
import RoundedProfilePicture from "../RoundedProfilePicture/RoundedProfilePicture";
import "./PatientTimeline.css";

//Icons import
import add from "../../assets/add.svg";
import infoRed from "../../assets/infoDanger.svg";
// import filter from "../../assets/filter.svg";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  ArrowIcon,
  CircleWithTickIcon,
  DownArrowIcon,
  ExclamatoryIcon,
  ExclamatoryRoundIcon,
  RefreshIcon,
  RotateIcon,
  ShareIcon
} from "../../assets/assets";
import bloodOxygen from "../../assets/blood-oxygen.svg";
import bloodPressure from "../../assets/blood-pressure.svg";
import bloodSugar from "../../assets/blood-sugar.svg";
import calorie from "../../assets/calorie.png";
import filterGrey from "../../assets/filterGrey.svg";
import heartRate from "../../assets/heart-rate.svg";
import heart from "../../assets/heart.png";
import height from "../../assets/height.svg";
import movement from "../../assets/movement.png";
import selectAllDocumentsActiveIcon from "../../assets/selectAllDocumentsActiveIcon.svg";
import selectAllDocumentsIcon from "../../assets/selectAllDocumentsIcon.svg";
import shoe from "../../assets/shoe.png";
import temperature from "../../assets/temperature.svg";
import warning_icon from "../../assets/warning_icon.svg";
import weight from "../../assets/weight.svg";
import {
  convertAbdmToNintoDocumentTypes,
  getMenuItems,
  getRemainingTime
} from "../../utils/constants";
import Modal from "../Modal/Modal";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const uniqueNamesForFilter = (data, _type) => {
  if (data && isValidArray(data) && data.length > 0) {
    let names = {};
    data.forEach((doc) => {
      if (doc.clinicId) {
        names = {
          ...names,
          [doc.clinicId]: { name: doc.clinicName, docId: doc.clinicId }
        };
      }
    });
    return names;
  } else return {};
};

//Timestamp to date converter
const dateAndTimeConverter = (timestamp, mode = "date") => {
  if (!timestamp) return;
  const dateObject = new Date(timestamp);

  const date = dateObject.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

  const time = dateObject.toLocaleString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });

  if (mode === "time") return time;
  if (mode === "both") return `${date}, ${time}`;
  return date;
};

function PatientTimeline(props) {
  const [sort, setSort] = useState("recentFirst");
  const timeline = useRef(null);
  const timelineMenu = useRef(null);
  const [lockerExpiringSoon, setLockerExpiringSoon] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [expiryTime, setExpiryTime] = useState("");

  useEffect(() => {
    if (props.isShared) {
      return;
    }

    if (typeof props.fetchDocumentShare !== "function") {
      return;
    }

    props.fetchDocumentShare?.(props.viewerId);
    setExpiryTime(getRemainingTime(props.documentShare?.expiresAt));

    const fetchInterval = setInterval(() => {
      if (props.documentShare) {
        setExpiryTime(getRemainingTime(props.documentShare?.expiresAt));

        if (
          props.documentShare.revoked ||
          props.documentShare?.expiresAt <= Date.now()
        ) {
          props.fetchDocumentShare?.(props.viewerId);
          clearInterval(fetchInterval);
          navigate("..");
        }
      }
    }, 60000);

    return () => clearInterval(fetchInterval);

    // eslint-disable-next-line
  }, [props.viewerId, props.documentShare?.documentId]);

  //for getting profile picture
  // useEffect(() => {
  //   if (isValidArray(props.documents)) {
  //     for (const document of props.documents) {
  //       if (
  //         document &&
  //         document.from &&
  //         document.from.id &&
  //         document.from.type &&
  //         document.from.type !== "patient" &&
  //         typeof props.getDocumentsCardProfilePicture === "function"
  //       )
  //         props.getDocumentsCardProfilePicture(
  //           document.from.type,
  //           document.from.id
  //         );
  //     }
  //   }
  //  // eslint-disable-next-line
  // }, [props.documents]);

  // const onScroll = () => {
  //   if (timeline.current === null) {
  //     return;
  //   }
  //   const menuElement = timeline.current.getElementsByTagName("section")?.[0];
  //   const viewportOffset = menuElement.getBoundingClientRect();

  //   if (viewportOffset.top > 120) {
  //     return;
  //   }

  //   menuElement.style.position = "sticky";
  //   menuElement.style.top = "0px";
  //   menuElement.style.zIndex = "1";
  //   menuElement.style.backgroundColor = "white";
  // };

  // const convertMouseScrollToHorizontalScroll = (event) => {
  //   if (timelineMenu.current === null) {
  //     return;
  //   }
  //   const scrollValue = 20; // How many pixels to scroll

  //   if (event.deltaY > 0)
  //     // if deltaY greater than 0 means user scroll verticalScroll right
  //     timelineMenu.current.scrollLeft += scrollValue;
  //   // Scroll left
  //   else timelineMenu.current.scrollLeft -= scrollValue;
  //   event.preventDefault();
  // };

  // for converting Mouse Scroll To HorizontalScroll
  // useEffect(() => {
  //   const parentElement = timeline.current.parentElement;
  //   const timelineMenus = timelineMenu.current;
  //   parentElement.addEventListener("scroll", onScroll);
  //   timelineMenu.current.addEventListener(
  //     "wheel",
  //     convertMouseScrollToHorizontalScroll,
  //     false
  //   );
  //   return () => {
  //     parentElement.removeEventListener("scroll", onScroll);
  //     timelineMenus.removeEventListener(
  //       "wheel",
  //       convertMouseScrollToHorizontalScroll
  //     );
  //   };
  // }, []);

  //Filter menu data array

  const showShowUploadButton = () => {
    return (
      props.hideUploadButton !== true &&
      Array.isArray(props.allowedUploadDocuments) &&
      props.allowedUploadDocuments.length > 0 &&
      !props.loading
    );
  };

  const [filteredDocuments, setFilteredDocuments] = useState([]);

  useEffect(() => {
    const {
      documentType = [],
      doctors = [],
      clinics = [],
      careContext = []
    } = props.filterState || {};

    const matchesDocumentType = (document) => {
      if (!documentType.length) {
        return true;
      }

      return documentType.some((type) => {
        if (
          document.documentType === "HealthDocumentRecord" &&
          type === "others"
        ) {
          return true;
        }

        return convertAbdmToNintoDocumentTypes(document.documentType) === type;
      });
    };

    const matchesCareContextDocumentId = (document) =>
      !careContext.length ||
      careContext.includes(document.transferData?.careContextId) ||
      careContext.includes(document.careContextDocumentId);

    const matchesDoctor = (document) =>
      !doctors.length || doctors.includes(document.name);

    const matchesClinic = (document) =>
      !clinics.length ||
      clinics.includes(document.transferData?.hip?.id) ||
      clinics.includes(document.clinicId);

    const result = props.documents
      ?.filter(
        (document) =>
          matchesDocumentType(document) &&
          matchesCareContextDocumentId(document) &&
          matchesDoctor(document) &&
          matchesClinic(document)
      )
      .sort((a, b) =>
        sort === "oldestFirst"
          ? a.uploadedAt?.timestamp - b.uploadedAt?.timestamp
          : b.uploadedAt?.timestamp - a.uploadedAt?.timestamp
      );

    setFilteredDocuments(result);
  }, [props.documents, props.filterState, sort]);

  return (
    <div className=" inherit-parent-height inherit-parent-width position-relative font-color-secondary">
      {/* Document upload modal button */}

      <div
        ref={timeline}
        className={`inherit-parent-height display-flex flex-direction-column`}
      >
        {showShowUploadButton() === true && (
          <Button
            name="filter-menu"
            data-cy="HOME-UPLOAD-BUTTON"
            buttonCategory="floating"
            position="bottom-right"
            src={add}
            iconClassName="home-upload-icon-height"
            onClick={() => {
              navigate("/patientTimeline/options");
            }}
          />
        )}

        {props.showRetryButton && !props.loading && (
          <div
            data-cy="RETRY-BUTTON"
            className={`position-absolute bottom-80px right-16px width-32px height-32px flex-align-items-center flex-justify-content-center box-shadow-default background-color-white border-radius-default cursor-pointer`}
            onClick={props.retryButtonOnClick}
            style={{ boxShadow: "0px 2px 2px 0px #0000001F" }}
          >
            <div
              style={{
                transform: "scale(0.9)",
                width: "16px",
                height: "16px"
              }}
            >
              <RefreshIcon />
            </div>
          </div>
        )}

        {!props.hideShare && !props.loading && !props.isShared && (
          <div
            data-cy="SHARE-BUTTON"
            className={`${
              props.showRetryButton ? "bottom-120px" : "bottom-80px"
            } position-absolute right-16px width-32px height-32px flex-align-items-center flex-justify-content-center box-shadow-default background-color-white border-radius-default cursor-pointer`}
            onClick={() => {
              navigate("/patientTimeline/share");
            }}
            style={{ boxShadow: "0px 2px 2px 0px #0000001F" }}
          >
            <ShareIcon />
            {props.documentShare && expiryTime && (
              <div
                className="position-absolute"
                style={{
                  width: "12px",
                  borderRadius: "100%",
                  height: "12px",
                  top: "-4px",
                  right: "-2px",
                  border: "2px solid white",
                  background: "#00A000",
                  padding: "2px",
                  boxShadow: "2px 0px 2px 0px #0000001F"
                }}
              />
            )}
          </div>
        )}

        {/* Documents filter nav menu */}
        <DocumentsFilterMenu
          kycStatus={props.kycStatus}
          kycStatusClick={props.kycStatusClick}
          ref={timelineMenu}
          menuData={getMenuItems(props.filterState)}
          menuItems={props.documentFilterMenu}
          menuOnClick={(menuItem) => {
            if (typeof props.onFilterClick === "function") {
              props.onFilterClick("document", menuItem);
            }
          }}
          filterType={props.filterState.documentType}
          doctorsName={props.filterState.doctors}
          clinicsName={props.filterState.clinics}
          filterButtonOnClick={() => {
            navigate(`${location.pathname}/filters`);
          }}
          setSort={(sortBy) => {
            setSort(sortBy);
          }}
          viewerType={props.viewerType}
          sort={sort}
          showGreyLine={!props.isShared}
        />

        {props.transferStatus && (
          <div className="inherit-parent-width flex-direction-column flex-justify-content-center">
            <div className="inherit-parent-width padding-top-default padding-bottom-small text-align-center font-size-small font-family-gilroy-regular">
              Transfer in-progress ...
            </div>
            <div className=" height-1px background-color-primary line inherit-parent-width">
              <div className="animated-gradient" />
            </div>
          </div>
        )}

        {!props.transferStatus && (
          <div className="inherit-parent-width flex-direction-column flex-justify-content-center">
            <div className="inherit-parent-width padding-top-default padding-bottom-small text-align-center font-size-large font-family-gilroy-regular">
              My linked records
            </div>
            <div className=" height-1px background-color-primary line inherit-parent-width">
              <div className="animated-gradient1" />
            </div>
          </div>
        )}

        {props.showExpiringSoon === true &&
          props.showExpired === false &&
          lockerExpiringSoon === true && (
            <LockerSubscriptionExpiringSoon
              remindMeLaterOnClick={() => setLockerExpiringSoon(false)}
              resubscribeOnClick={props.resubscribeOnClick}
              loading={props.resubscribeLoading}
            />
          )}

        {props.showExpired && (
          <LockerSubscriptionExpired
            resubscribeOnClick={props.resubscribeOnClick}
            loading={props.resubscribeLoading}
          />
        )}

        <div className="inherit-parent-width inherit-parent-height hide-scroll-bar">
          {props.loading === true ? (
            <TimelineSuspense />
          ) : (
            <div
              className="max-width-550px margin-horizontal-auto flex-align-items-center inherit-parent-width flex-direction-column flex-grow-1 inherit-parent-height"
              data-cy="home-page-content"
            >
              {isValidArray(filteredDocuments) ||
              isValidArray(props.pendingDocumentUploads) ? (
                <div
                  className={`inherit-parent-width ${
                    props.overflowHidden ? "overflow-hidden" : " "
                  } ${props.removeScrollBar ? "" : "hide-scroll-bar"}`}
                >
                  {props.pendingDocumentUploads?.map((data, i) => (
                    <React.Fragment key={i}>
                      <PendingDocumentCard data={data} />
                    </React.Fragment>
                  ))}

                  {props.dataTransfer
                    ?.filter((data) => data.status === "FAILED")
                    ?.map((document, index) => (
                      <DocumentCard
                        profilePictureSize={props.profilePictureSize}
                        key={`${document.documentId}-parent`}
                        document={document}
                        documents={filteredDocuments}
                        index={index}
                        documentCardOnClick={(document) => {
                          props.documentCardOnClick(document);
                        }}
                        status="failed"
                        getAudioUrl={props.getAudioUrl}
                        profilePictures={props.profilePictures}
                        downloads={props.downloads}
                        viewerId={props.viewerId}
                        patientName={props.patientName}
                        viewerType={props.viewerType}
                      />
                    ))}
                  {filteredDocuments?.map((document, index) => (
                    <React.Fragment key={document.documentId}>
                      {document.processing === true ? (
                        <DocumentsCardSuspense
                          profilePictureSize={props.profilePictureSize}
                          keyValue={document.healthId}
                        />
                      ) : (
                        <DocumentCard
                          profilePictureSize={props.profilePictureSize}
                          key={`${document.documentId}-parent`}
                          document={document}
                          documents={props.documents}
                          index={index}
                          documentCardOnClick={(document) => {
                            props.documentCardOnClick(document);
                          }}
                          // status="failed"
                          getAudioUrl={props.getAudioUrl}
                          profilePictures={props.profilePictures}
                          downloads={props.downloads}
                          viewerId={props.viewerId}
                          patientName={props.patientName}
                          viewerType={props.viewerType}
                        />
                      )}
                    </React.Fragment>
                  ))}
                  {props.consentsEnds && (
                    <PatientAccessCard
                      requested={false}
                      patientAccessOnClick={props.patientAccessOnClick}
                    />
                  )}
                  {props.paginationLoading === true && (
                    <div className="flex-justify-content-center padding-vertical-small margin-bottom-larger inherit-parent-width">
                      <div className="display-flex-direction-row flex-justify-content-center flex-align-items-center inherit-parent-width">
                        <p>Loading</p>{" "}
                        <div className="padding-horizontal-medium" />
                        <div className={`dot-flashing`} />
                        <div className="padding-horizontal-medium" />
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <NoDocumentsFound />
              )}
            </div>
          )}

          <Routes>
            <Route
              path="filters"
              element={
                <FilterModal
                  onClearFilterClick={props.onClearFilterClick}
                  documents={props.documents}
                  filterState={props.filterState}
                  onFilterClick={props.onFilterClick}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

PatientTimeline.propType = {
  /**
   * array of objects to render the patient timeline
   */
  documents: PropTypes.arrayOf(PropTypes.object.isRequired),
  /**
   * loading state for the timeline shows the suspense of document card
   */
  loading: PropTypes.bool,
  /**
   * state which is used to filter the patient timeline cards, filter state is a object which contains `documentType as array`, `doctors name as array` and `clinics name as array`
   * each array contains the values which is need be filter
   */
  filterState: PropTypes.shape({
    documentType: PropTypes.arrayOf(PropTypes.string),
    doctors: PropTypes.arrayOf(PropTypes.string),
    clinics: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  /**
   * function which gives document uploader userType and userId, to get the profile picture of uploader. Example `getDocumentsCardProfilePicture(userType,userId)`
   */
  getDocumentsCardProfilePicture: PropTypes.func.isRequired,
  /**
   * which is used to control the document filter menu. it will render the menu items only if mentioned.
   * allowed menu Items `symptom` `prescription` `report` `vitals` `receipt` `admission` `insurance`
   */
  documentFilterMenu: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * function which gives clicked menu item type.Example `onFilterClick={(filterType,filterValue)=>{}}`
   */
  onFilterClick: PropTypes.func.isRequired,
  /**
   * which returns the document type and documentId of the clicked document
   */
  documentCardOnClick: PropTypes.func,
  /**
   * which is used to get the audio url of symptom
   * `getAudioUrl={(documentId)=>{}}`
   */
  getAudioUrl: PropTypes.func,
  /**
   * object of profile picture urls `profilePictures={'someId':src for image}
   */
  profilePictures: PropTypes.objectOf({
    patients: PropTypes.object,
    doctors: PropTypes.object,
    clinics: PropTypes.object
  }),
  /**
   * download url for the document assets
   */
  downloads: PropTypes.object,
  /**
   * user who viewing the document
   */
  viewerId: PropTypes.string.isRequired,
  /**
   * patientName
   */
  patientName: PropTypes.string,
  /**
   * viewerType `doctor` `patient` `clinic`
   */
  viewerType: PropTypes.oneOf(["patient", "doctor", "clinic"]),
  /**
   * To clear doctor name filter and clinic name filter
   */
  onClearFilterClick: PropTypes.func,
  /**
   * Used to control which documents are allowed to upload. allowed documents to uploads are `symptom` `prescription` `report` `vitals` `receipt` `admission` `insurance`
   */
  allowedUploadDocuments: PropTypes.arrayOf(PropTypes.string),
  /**
   * profilePictureSize `medium` `small` `smaller` `large`
   */
  profilePictureSize: PropTypes.string
};

PatientTimeline.defaultProps = {
  documents: [],
  loading: false,
  getDocumentsCardProfilePicture: undefined,
  filterState: {
    documentType: [],
    doctors: [],
    clinics: []
  },
  filterType: [],
  documentFilterMenu: ["symptom"],
  onFilterClick: undefined,
  documentCardOnClick: undefined,
  getAudioUrl: undefined,
  profilePictures: {
    patients: null,
    doctors: null,
    clinics: null
  },
  downloads: null,
  viewerId: "",
  viewerType: "patient",
  onClearFilterClick: () => {},
  allowedUploadDocuments: [""]
};

export default PatientTimeline;

function FilterModal(props) {
  const [filterBy, setFilterBy] = useState("clinics");
  const navigate = useNavigate();

  return (
    <Modal
      show={true}
      onClose={() => {
        navigate("..");
      }}
      canIgnore={true}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
      height="height-fit-to-content"
    >
      <div className="background-white border-top-radius-default padding-default font-family-gilroy-medium user-select-none">
        <div className="flex-justify-content-space-between flex-align-items-center font-size-medium font-color-secondary padding-default ">
          <div className=" ">
            Filters
            <img
              src={filterGrey}
              className="padding-left-default"
              height="12px"
              // width="auto"
              alt="filter-icon"
            />
          </div>
          <div
            className="cursor-pointer"
            onClick={props.onClearFilterClick}
            data-cy="clearFilter"
          >
            Clear
          </div>
        </div>
        <div className="display-flex font-size-medium font-family-gilroy-medium text-align-left">
          <div className="border-right-1px padding-right-default flex-basis-30-percentage">
            {/* <div
                className={` cursor-pointer margin-bottom-default padding-default border-radius-default ${
                  filterBy.includes("doctors") && "background-color-grey"
                }`}
                onClick={() => {
                  setFilterBy("doctors");
                }}
                data-cy="doctorFilter"
              >
                Doctors
              </div> */}
            <div
              className={` cursor-pointer margin-bottom-default padding-default border-radius-default ${
                filterBy.includes("clinics") && "background-color-grey"
              }`}
              onClick={() => {
                setFilterBy("clinics");
              }}
              data-cy="clinicFilter"
            >
              Clinics
            </div>
          </div>
          <div className="display-flex flex-wrap font-color-secondary padding-left-default">
            {/* doctor names filter chips */}
            {filterBy === "doctors" &&
              isValidObject(uniqueNamesForFilter(props.documents, "doctor")) &&
              Object.values(
                uniqueNamesForFilter(props.documents, "doctor")
              ).map((data, index) => (
                <span
                  data-cy={data.docId}
                  key={index}
                  className={`padding-default border-radius-default background-white margin-horizontal-default height-fit-to-content ${
                    props.filterState.doctors.includes(data.docId)
                      ? "background-color-grey"
                      : "box-shadow-secondary"
                  }`}
                  onClick={() => {
                    typeof props.onFilterClick === "function" &&
                      props.onFilterClick("doctor", data.docId);
                    // doctorsNameFilterHandler(name);
                  }}
                >
                  {data.name}
                </span>
              ))}
            {/* clinic names filter chips */}
            {filterBy === "clinics" &&
              isValidObject(uniqueNamesForFilter(props.documents, "clinic")) &&
              Object.values(
                uniqueNamesForFilter(props.documents, "clinic")
              ).map((data, index) => (
                <span
                  data-cy={data.docId}
                  key={index}
                  className={`padding-default border-radius-default background-white margin-horizontal-default height-fit-to-content ${
                    props.filterState.clinics.includes(data.docId)
                      ? "background-color-grey"
                      : "box-shadow-secondary"
                  }`}
                  onClick={() => {
                    props.onFilterClick("clinic", data.docId);
                  }}
                >
                  {data.name}
                </span>
              ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const PatientAccessCard = (props) => {
  return (
    <div
      onClick={props.patientAccessOnClick}
      className="flex-justify-content-space-between padding-large margin-large border-2px-lite-grey border-radius-default flex-center-children-vertically"
      data-cy="extend-consent-request-card"
    >
      <div className="flex-justify-content-center flex-direction-column">
        <div className="font-family-gilroy-regular font-size-default">
          {props.requested
            ? "Older records have been requested"
            : "Patient’s access ends here"}
        </div>
        <div className="font-family-gilroy-regular font-size-small padding-top-default">
          {props.requested
            ? "Click here to resend request"
            : "Click here to request further older records."}
        </div>
      </div>
      <div>
        <ArrowIcon />
      </div>
    </div>
  );
};

function PendingDocumentCard(props) {
  return (
    <div className=" padding-large border-bottom-1px">
      <div className=" font-weight-normal font-size-large font-family-gilroy-medium font-color-secondary  text-overflow-ellipsis white-space-nowrap overflow-hidden text-capitalize">
        {props.data?.documentName}
      </div>
      <div className=" display-flex flex-justify-content-space-between flex-align-items-center padding-top-default">
        <div className=" display-flex flex-align-items-center">
          <RoundedProfilePicture size={"small"} />
          <div className=" display-flex padding-left-default">
            <ExclamatoryRoundIcon />
            <div className=" font-color-red font-size-small padding-left-small">
              Waiting for internet
            </div>
          </div>
        </div>
        <DocumentChip
          // status={props.document?.status}
          document={props.data}
        />
      </div>
    </div>
  );
}

function DocumentCard(props) {
  // const authorName = (document) => {
  //   if (props.viewerId === document.from.id) {
  //     return "You";
  //   } else if (isValidObject(document)) {
  //     return document.from?.name;
  //   } else {
  //     return "";
  //   }
  // };
  return (
    <section
      data-cy={
        convertAbdmToNintoDocumentTypes(props.document.documentType) ===
        "symptom"
          ? props.document.description
          : props.document.documentName
      }
      className={`${
        props.status === "failed" ? "background-red-gradient" : ""
      } cursor-pointer padding-left-large padding-right-large padding-top-large flex-justify-content-space-between inherit-parent-width ${
        props.index === props.documents.length - 1
          ? "padding-bottom-for-last-timeline-card"
          : "border-bottom-1px padding-bottom-large"
      }`}
      onClick={() => {
        if (typeof props.documentCardOnClick === "function") {
          props.documentCardOnClick(props.document);
        }
      }}
      key={`${props.document.documentId}-${props.index}`}
    >
      <div className="inherit-parent-width overflow-hidden">
        <div className="font-color-secondary font-family-gilroy-medium font-size-small text-overflow-ellipsis white-space-no-wrap display-flex flex-justify-content-space-between">
          <div className="display-flex flex-justify-content-space-between inherit-parent-width overflow-hidden">
            {/* <div
              data-cy={`document-uploaded-by-${
                props.document.from
                  ? props.document.from.type === "patient"
                    ? "You"
                    : props.document.from.name
                  : "You"
              }`}
              className="white-space-nowrap text-overflow-ellipsis overflow-hidden flex-start-place-children-vertically text-transform-capitalize"
            >
              {authorName(props.document)}
            </div> */}
            {props.status === "failed" && (
              <div
                data-cy="document-title"
                className="font-weight-normal font-size-large font-family-gilroy-medium font-color-secondary display-flex text-overflow-ellipsis white-space-nowrap overflow-hidden"
              >
                <RotateIcon color="#4E4E4E" removeDot={true} />
                <div className="padding-left-default"> Tap to retry </div>
              </div>
            )}

            {((Object.hasOwn(props.document, "type") &&
              Object.hasOwn(props.document, "description")) ||
              Object.hasOwn(props.document, "name")) &&
              props.status !== "failed" && (
                <h5
                  data-cy="document-title"
                  className="font-weight-normal font-size-large font-family-gilroy-medium font-color-secondary  text-overflow-ellipsis white-space-nowrap overflow-hidden text-capitalize"
                >
                  {props.document.type === "symptom"
                    ? props.document?.description
                    : props.document?.documentName}
                </h5>
              )}
            <time className="flex-start-place-children-vertically">
              {dateAndTimeConverter(
                props.document.uploadedAt?.timestamp,
                "both"
              )}
            </time>
          </div>
        </div>
        {props.document?.type === "vital" ? (
          <VitalsCard document={props.document} />
        ) : props.document?.type === "fitness" ? (
          <FitnessCard document={props.document} />
        ) : (
          <React.Fragment>
            <div className="display-flex flex-center-children-vertically padding-top-default">
              <div className="display-flex flex-align-items-center ">
                {props.document.severityScale ? (
                  <SeverityScale value={props.document.severityScale} />
                ) : (
                  <RoundedProfilePicture
                    size={
                      props.profilePictureSize
                        ? props.profilePictureSize
                        : "small"
                    }
                    // src={
                    //   props.document.type === "fitness"
                    //     ? googleFit
                    //     : props.document.from.type === "patient"
                    //     ? props.profilePictures?.patients?.[props.document.from.id]
                    //     : props.document.from.type === "clinic"
                    //     ? props.profilePictures?.clinics?.[props.document.from.id]
                    //     : props.document.from.type === "doctor"
                    //     ? props.profilePictures?.doctors?.[props.document.from.id]
                    //     : null
                    // }
                  />
                )}
              </div>
              <div className="padding-left-default font-size-small inherit-parent-width display-flex flex-justify-content-space-between font-family-gilroy-regular">
                <div>
                  {(props.document?.transferData?.hip?.name
                    ? props.document?.transferData?.hip?.name
                    : props.document?.transferData?.hip?.id
                    ? props.document?.transferData?.hip?.id
                    : props.document?.clinicName
                    ? props.document?.clinicName
                    : props.document?.sender?.name
                  )?.toUpperCase()}
                </div>
                {(props.document.documentType ||
                  props.document?.status === "FAILED") && (
                  <div className="width-fit-content">
                    <DocumentChip
                      status={props.document?.status}
                      document={props.document}
                    />
                  </div>
                )}
              </div>
            </div>
            {props.document.type === "form" &&
              Array.isArray(props.document?.fields) &&
              (props.document?.fields.findIndex(
                (field) => field.required === true
              ) > -1
                ? props.document?.fields.some(
                    (field) =>
                      field?.value === undefined && field?.required === true
                  )
                : props.document?.fields.findIndex(
                    (field) => field.required === false
                  ) > -1
                ? props.document?.fields.every((field) => !field?.value)
                : false) && (
                <div
                  className=" display-flex flex-align-items-center padding-top-default"
                  data-cy={props.document?.name + "incomplete"}
                >
                  <img
                    src={infoRed}
                    alt=""
                    className="check-mark-icon-height"
                    // width={"auto"}
                  />
                  <span className="padding-left-small font-family-gilroy-regular">
                    Incomplete
                  </span>
                </div>
              )}
            {isValidObject(props.document.url) &&
              typeof props.document.url.audio === "string" &&
              props.document.url.audio.length > 0 && (
                <div
                  className=" padding-top-default"
                  onClick={(event) => event.stopPropagation()}
                >
                  <AudioPlayer
                    getDownloadURL={() =>
                      typeof props.getAudioUrl === "function" &&
                      props.getAudioUrl(props.document.documentId)
                    }
                    src={
                      isValidObject(props.downloads) &&
                      isValidObject(props.downloads.symptoms) &&
                      isValidObject(
                        props.downloads.symptoms[props.document.documentId]
                      )
                        ? props.downloads.symptoms[props.document.documentId]
                            .downloadUrl
                        : ""
                    }
                  />
                </div>
              )}
          </React.Fragment>
        )}
      </div>
    </section>
  );
}

const SeverityScale = (props) => {
  const degree = `${parseInt(props.value) * 18 + 180}deg`;
  return (
    <div className="severity-scale-parent-circle-size border-radius-top overflow-hidden background-color-grey flex-justify-content-center flex-align-items-center cursor-pointer">
      <div className="position-relative severity-scale-wrap-size border-radius-top overflow-hidden">
        <div
          className="severity-scale-size-top background-color-grey border-radius-top transform-origin-bottom"
          style={{
            transform: `rotate(${degree})`,
            background: `${
              parseInt(props.value) >= 1 && props.value <= 3
                ? "#00a000"
                : parseInt(props.value) >= 4 && props.value <= 7
                ? "#FFE600"
                : parseInt(props.value) > 7 && props.value <= 10
                ? "#E64539"
                : "transparent"
            }`
          }}
        />
        <div className="severity-scale-size-bottom position-absolute background-white" />
        <div className="position-absolute-center-self background-white border-radius-50-percentage severity-scale-value-circle-size flex-place-children-page-center font-color-secondary font-size-smaller box-shadow-default">
          {props.value ? props.value : "6"}
        </div>
      </div>
    </div>
  );
};

const DocumentsCardSuspense = ({ profilePictureSize, keyValue }) => {
  return (
    <div
      key={keyValue}
      data-cy="documents-card-suspense"
      className="padding-top-larger padding-bottom-larger padding-left-large padding-right-large border-bottom-1px flex-justify-content-space-between inherit-parent-width"
    >
      <div className="inherit-parent-width overflow-hidden display-flex flex-direction-column">
        <div className="display-flex flex-justify-content-space-between ">
          <div className="shimmer margin-left-default margin-bottom-default border-radius-default font-size-large font-family-gilroy-medium font-color-secondary padding-default text-overflow-ellipsis white-space-nowrap overflow-hidden width-50-percentage" />
          <div className="shimmer margin-left-default margin-bottom-default border-radius-default font-size-large font-family-gilroy-medium font-color-secondary padding-default text-overflow-ellipsis white-space-nowrap overflow-hidden width-20-percentage" />
        </div>
        <div className="display-flex padding-top-large flex-align-items-center">
          <RoundedProfilePicture
            size={profilePictureSize || "small"}
            loading={true}
          />
          <div className="display-flex flex-direction-column width-40-percentage">
            <div className="shimmer margin-left-default margin-bottom-default border-radius-default font-size-large font-family-gilroy-medium font-color-secondary padding-default text-overflow-ellipsis white-space-nowrap overflow-hidden width-60-percentage" />
            <div className="shimmer margin-left-default border-radius-default font-size-large font-family-gilroy-medium font-color-secondary padding-default text-overflow-ellipsis white-space-nowrap overflow-hidden width-40-percentage" />
          </div>
        </div>
      </div>
    </div>
  );
};

const NoDocumentsFound = () => {
  return (
    <section
      className="text-align-center max-width-500px flex-place-children-page-center inherit-parent-height padding-larger"
      data-cy="empty-documents-fallback"
    >
      <img
        src={emptyDocument}
        alt="empty-doc"
        // width="auto"
        height="150px"
        className="padding-default"
      />
      <div className="font-family-gilroy-bold font-size-medium font-color-secondary padding-default">
        No records found.
      </div>
      <div className="font-family-gilroy-medium font-size-medium font-color-secondary padding-default">
        Start by adding your previous prescriptions, reports, or symptoms
      </div>
    </section>
  );
};

const TimelineSuspense = () => {
  return (
    <article
      className="screen-loader-wrapper flex-center-children-horizontally inherit-parent-height inherit-parent-width overflow-hidden"
      data-cy="patient-timeline-suspense"
    >
      <main className="max-width-588px inherit-parent-width">
        {[...Array(5)].map((_data, index) => (
          <div
            className=" padding-top-larger padding-left-large padding-right-large border-bottom-1px-e5e5e5"
            key={index}
          >
            <div className=" display-flex flex-justify-content-space-between ">
              <div className="shimmer  padding-default border-radius-default padding-right-larger padding-left-larger ">
                <div className="padding-left-larger padding-right-larger" />
              </div>
              <div className="shimmer  border-radius-default padding-right-larger padding-left-larger padding-top-large ">
                <div className="padding-left-larger padding-right-large" />
              </div>
            </div>

            <div className="flex-center-children-vertically padding-top-large  padding-bottom-larger">
              <div className="shimmer padding-large border-radius-50-percentage height-width-16px" />
              <div className=" margin-left-default">
                <div className="shimmer  padding-default border-radius-default width-200px " />
                <div className="shimmer margin-top-default padding-small border-radius-default width-150px ">
                  <div className=" padding-smaller" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </main>
    </article>
  );
};

//Document type filter nav menu
const DocumentsFilterMenu = React.forwardRef((props, ref) => {
  return (
    <div>
      {props.showGreyLine && (
        <div
          style={{
            height: "1px"
          }}
          className={`grey-line  ${
            props.viewerType === "clinic" || props.viewerType === "doctor"
              ? "margin-bottom-default"
              : ""
          }`}
        />
      )}

      <div className="flex-justify-content-space-between flex-align-items-center font-size-medium font-color-secondary margin-bottom-default padding-right-large padding-left-large">
        <div
          className=" cursor-pointer display-flex flex-align-items-center white-space-no-wrap"
          onClick={() => {
            if (props.sort === "oldestFirst") {
              props.setSort("resentFirst");
            } else {
              props.setSort("oldestFirst");
            }
          }}
          style={{
            width: "90px"
          }}
          data-cy="sortBy"
        >
          <div>
            <span className=" font-family-gilroy-medium">
              {" "}
              {`${
                props.sort === "oldestFirst" ? " Oldest" : " Recent"
              }`} first{" "}
            </span>
          </div>

          <div
            className={`${
              props.sort === "oldestFirst" ? "rotate-180" : ""
            } margin-left-small display-flex flex-align-items-center`}
          >
            <DownArrowIcon />
          </div>
        </div>

        {typeof props.kycStatusClick === "function" && (
          <div
            onClick={props.kycStatusClick}
            className="position-relative cursor-pointer flex-justify-content-center display-flex flex-align-items-center "
          >
            <div className="trapezoid" />
            <div className="position-absolute display-flex white-space-no-wrap">
              {props.kycStatus && props?.kycStatus === "VERIFIED"
                ? "KYC Verified"
                : "Self Declared"}
              <div className="display-flex flex-align-items-center padding-left-default">
                {props?.kycStatus && props?.kycStatus === "VERIFIED" ? (
                  <CircleWithTickIcon
                    circleColor="#f5f5f5"
                    circleOutline="#00a000"
                    tickColor="#00a000"
                  />
                ) : (
                  <ExclamatoryIcon />
                )}
              </div>
            </div>
          </div>
        )}
        <div
          className=" font-family-gilroy-medium display-flex flex-align-items-center "
          onClick={() => {
            props.filterButtonOnClick();
          }}
        >
          <div className="white-space-no-wrap">
            Add filters{" "}
            <span className="font-size-small">{`${
              props.clinicsName.length > 0 && props.doctorsName.length > 0
                ? "(2)"
                : props.clinicsName.length > 0 || props.doctorsName.length > 0
                ? "(1)"
                : ""
            }`}</span>
          </div>
          <div className="display-flex flex-align-items-start">
            <img
              src={filterGrey}
              className="padding-left-default"
              height="12px"
              alt="filter-icon"
            />
          </div>
        </div>
      </div>
      <section className="padding-horizontal-small display-flex flex-align-items-start height-10px inherit-parent-width flex-justify-content-space-between">
        <ul
          ref={ref}
          className="display-flex overflow-x-scroll hide-scroll-bar flex-align-items-center margin-vertical-default timeline-menu-scroll-bar"
        >
          <li
            data-cy="all-filter"
            key="all"
            className="flex-place-children-page-center margin-horizontal-small cursor-pointer timeline-menu-item-min-width"
            onClick={(event) => {
              rippleEffect(event);
              props.menuOnClick("allDocuments");
            }}
          >
            <div
              data-cy="all-filter-text"
              className={`${
                props.filterType.length === 0
                  ? "border-1px-F1F1F1 background-color-grey font-color-black "
                  : "border-1px-e5e5e5 font-color-secondary "
              } display-flex flex-align-items-center width-fit-content padding-left-default padding-right-medium padding-top-smaller padding-bottom-smaller font-family-gilroy-regular font-size-small border-radius-default text-transform-capitalize`}
            >
              {props.filterType.length !== 0 ? (
                <img
                  src={selectAllDocumentsIcon}
                  alt="select All Icon"
                  className="filter-icon-height-and-width background-color-transparent  "
                  data-cy={"selectAllDocumentsIcon"}
                />
              ) : (
                <img
                  src={selectAllDocumentsActiveIcon}
                  alt="select All Active Icon"
                  className="filter-icon-height-and-width background-color-transparent"
                  data-cy="selectAllDocumentsActiveIcon"
                />
              )}

              {"All"}
            </div>
          </li>
          {props.menuData.map(
            (data, _index) =>
              props.menuItems.some((item) => {
                return item === data.type;
              }) && (
                <li
                  data-cy={`${data.type}-filter`.toUpperCase()}
                  key={data.type}
                  className="flex-place-children-page-center margin-horizontal-small cursor-pointer timeline-menu-item-min-width"
                  onClick={(event) => {
                    rippleEffect(event);
                    props.menuOnClick(data.type);
                  }}
                >
                  <div
                    data-cy={`${data.type.toUpperCase()}-${
                      props.filterType.includes(data.type)
                        ? "ACTIVE"
                        : "INACTIVE"
                    }`}
                    className={`${
                      props.filterType.some((text) => text === data.type)
                        ? "border-1px-F1F1F1 background-color-grey font-color-black "
                        : "border-1px-e5e5e5 font-color-secondary "
                    } display-flex flex-align-items-center width-fit-content padding-left-default padding-right-medium padding-top-smaller padding-bottom-smaller font-family-gilroy-regular font-size-small border-radius-default text-transform-capitalize`}
                  >
                    <img
                      src={data.icon}
                      alt={data.alt}
                      className={`${data.widthHeight} background-color-transparent `}
                      data-cy={data.alt}
                    />

                    {data.filterMenuText}
                  </div>
                </li>
              )
          )}
        </ul>
        {/* Filter modal button */}
      </section>
    </div>
  );
});

DocumentsFilterMenu.displayName = "DocumentsFilterMenu";

const DocumentChip = (props) => {
  return (
    <div
      data-cy={`${convertAbdmToNintoDocumentTypes(
        props.document?.documentType
      )}-chip`.toUpperCase()}
      className={`${
        props.status === "FAILED"
          ? "font-color-red background-failed"
          : "background-color-grey"
      } border-radius-default font-size-smaller padding-left-medium padding-right-medium height-fit-to-content flex-place-children-page-center padding-top-smaller padding-bottom-smaller font-family-gilroy-regular text-transform-capitalize`}
    >
      {props.document?.documentType
        ? convertAbdmToNintoDocumentTypes(
            props.document?.documentType
          ).toUpperCase()
        : "Transfer error"}
    </div>
  );
};

const VitalsCard = (vital) => {
  return (
    <div
      className="inherit-parent-width flex-start flex-wrap"
      onClick={vital.onClick}
    >
      {/*  heartRate */}
      {Object.hasOwn(vital.document, "heartRate") && (
        <VitalsDataCard
          unit="BPM"
          src={heartRate}
          value={vital?.document?.heartRate?.value}
          title={"Heart rate"}
          data-cy="heart-rate-card"
        />
      )}

      {/*  body temperature */}
      {Object.hasOwn(vital.document, "bodyTemperature") && (
        <VitalsDataCard
          unit="°F"
          src={temperature}
          value={vital?.document?.bodyTemperature?.value}
          title={"Temperature"}
          data-cy="temperature-card"
        />
      )}

      {/*  blood pressure */}
      {Object.hasOwn(vital.document, "bloodPressure") && (
        <VitalsDataCard
          unit="mmHg"
          src={bloodPressure}
          value={vital?.document?.bloodPressure?.value}
          title={"Blood pressure"}
          data-cy="blood-pressure-card"
        />
      )}

      {/*  blood oxygen */}
      {Object.hasOwn(vital.document, "bloodOxygen") && (
        <VitalsDataCard
          unit="%"
          src={bloodOxygen}
          value={vital?.document?.bloodOxygen?.value}
          title={"SpO2"}
          data-cy="blood-oxygen-card"
        />
      )}

      {/*  blood sugar */}
      {Object.hasOwn(vital.document, "bloodSugar") && (
        <VitalsDataCard
          unit="mmol/L"
          src={bloodSugar}
          value={vital?.document?.bloodSugar?.value}
          title={"Blood sugar"}
          data-cy="blood-sugar-card"
        />
      )}

      {/*  height */}
      {Object.hasOwn(vital.document, "height") && (
        <VitalsDataCard
          src={height}
          unit="CM"
          value={vital?.document?.height}
          title={"Height"}
          data-cy="height-card"
        />
      )}

      {/*  weight */}
      {Object.hasOwn(vital.document, "weight") && (
        <VitalsDataCard
          src={weight}
          unit="KG"
          value={vital?.document?.weight}
          title={"Weight"}
          data-cy="weight-card"
        />
      )}
    </div>
  );
};

const VitalsDataCard = (vitalData) => {
  return (
    <div
      className="width-50-percentage display-flex flex-align-items-center padding-bottom-default padding-top-default font-family-gilroy-regular"
      data-cy={vitalData["data-cy"]}
    >
      <img
        src={vitalData.src}
        alt=""
        className="vital-data-card-icon-size"
        // width="auto"
      />
      <div className="display-flex flex-direction-column padding-left-small">
        <span className="font-color-secondary font-size-smaller">
          {vitalData.title}
        </span>
        <span className="font-size-medium padding-top-small">
          {vitalData.value} {vitalData.unit}
        </span>
      </div>
    </div>
  );
};

const FitnessCard = (fitness) => {
  const [isWeeklyAverage, setIsWeeklyAverage] = useState(false);

  const value = (value) => {
    if (isWeeklyAverage) {
      return Math.round(value / 7);
    } else {
      return value;
    }
  };
  return (
    <React.Fragment>
      <div className=" padding-top-medium font-family-gilroy-regular ">
        {new Date(fitness.document.duration.startingTime).getDate()}-
        {new Date(fitness.document.duration.endingTime).getDate()}{" "}
        {new Date(fitness.document.duration.endingTime).toLocaleString(
          "en-us",
          { month: "short" }
        )}{" "}
        Summary
      </div>
      <div
        className="inherit-parent-width flex-start flex-wrap"
        onClick={fitness.onClick}
        data-cy={"google-fit-data"}
      >
        {Object.hasOwn(fitness.document, "heartPoints") && (
          <FitnessDataWidget
            src={heart}
            value={value(fitness?.document?.heartPoints)}
            title={`Heart pts ${isWeeklyAverage ? "(per day)" : ""}`}
            data-cy="heart-card"
          />
        )}
        {Object.hasOwn(fitness.document, "stepCount") && (
          <FitnessDataWidget
            src={shoe}
            value={value(fitness?.document?.stepCount)}
            title={`Steps ${isWeeklyAverage ? "(per day)" : ""}`}
            data-cy="steps-card"
          />
        )}
        {Object.hasOwn(fitness.document, "caloriesBurned") && (
          <FitnessDataWidget
            src={calorie}
            value={value(fitness?.document?.caloriesBurned)}
            title={`Cal ${isWeeklyAverage ? "(per day)" : ""}`}
            data-cy="calorie-card"
          />
        )}
        {Object.hasOwn(fitness.document, "moveMinutes") && (
          <FitnessDataWidget
            src={movement}
            value={value(fitness?.document?.moveMinutes)}
            title={`Move min ${isWeeklyAverage ? "(per day)" : ""}`}
            data-cy="movement-card"
          />
        )}
      </div>
      <section className=" padding-top-large display-flex  flex-align-items-center">
        <ToggleSwitch
          name={
            fitness.document?.documentId
              ? fitness.document?.documentId
              : +new Date()
          }
          label={isWeeklyAverage ? "Weekly average" : "Weekly total"}
          onChange={(event) => {
            setIsWeeklyAverage(event.target.checked);
          }}
        />
      </section>
    </React.Fragment>
  );
};

const FitnessDataWidget = (fitness) => {
  return (
    <div
      className="width-50-percentage flex-start flex-direction-column padding-bottom-default padding-top-default font-family-gilroy-regular"
      data-cy={fitness["data-cy"]}
    >
      <div className="display-flex flex-align-items-center ">
        <img
          src={fitness.src}
          alt=""
          className="fitness-data-icon-height"
          // width="auto"
        />
        <span className="font-size-medium padding-top-small padding-left-small">
          {Math.round(fitness.value)}
        </span>
      </div>
      <span className="font-color-secondary font-size-smaller padding-top-smaller ">
        {fitness.title}
      </span>
    </div>
  );
};

const LockerSubscriptionExpiringSoon = (props) => {
  return (
    <div className=" padding-default ">
      <section className=" margin-default padding-default display-flex  flex-direction-column flex-justify-content-center border-2px-lite-grey border-radius-default">
        <div className="display-flex margin-default flex-direction-row flex-justify-content-space-between">
          <div>
            <h3 className=" font-family-gilroy-medium font-size-medium font-color-secondary">
              Health locker access expiring soon
            </h3>

            <div className=" font-family-gilroy-regular font-color-secondary font-size-small line-height-140-percentage padding-top-small">
              Please re-subscribe to view & add your records.
            </div>
          </div>

          <img
            src={warning_icon}
            alt=""
            draggable={false}
            // width="auto"
            height="14"
            className=" margin-top-medium  "
          />
        </div>

        <div className=" display-flex margin-top-default">
          <Button
            boxShadow={false}
            data-cy="resubscribe-button"
            text="Resubscribe"
            className=" margin-default font-weight-normal"
            onClick={props.resubscribeOnClick}
            loading={props.loading}
          />
          <Button
            boxShadow={false}
            data-cy="remind-me-later-button"
            text="Remind me later"
            className="margin-default font-size-small"
            variant="secondary"
            onClick={props.remindMeLaterOnClick}
          />
        </div>
      </section>
    </div>
  );
};

const LockerSubscriptionExpired = (props) => {
  return (
    <div className=" padding-default margin-default">
      <section className=" padding-large display-flex  flex-direction-column flex-align-items-center flex-justify-content-center border-2px-lite-grey border-radius-default">
        <h3 className=" font-family-gilroy-medium font-size-medium font-color-secondary">
          Ninto health locker access expired!
        </h3>

        <p className=" text-align-center font-family-gilroy-regular font-color-secondary font-size-small line-height-140-percentage padding-top-small display-flex flex-align-items-center flex-justify-content-center">
          Please re-subscribe to view & add your records plus access all health
          locker access
        </p>

        <Button
          boxShadow={false}
          data-cy="CONNECT-ABDM-BUTTON"
          text="Resubscribe now"
          className=" margin-top-large"
          onClick={props.resubscribeOnClick}
          loading={props.loading}
        />
      </section>
    </div>
  );
};
